"use client";

import { useState, useEffect, useCallback } from 'react';

// Global state to allow sharing mobile details toggle without prop drilling
let globalShowMobileDetails = false;
const listeners = new Set<(show: boolean) => void>();

export function useMobileDetails() {
  const [showMobileDetails, setShowMobileDetailsState] = useState(globalShowMobileDetails);

  useEffect(() => {
    // Sync with global state on mount
    setShowMobileDetailsState(globalShowMobileDetails);
    
    // Subscribe to changes
    listeners.add(setShowMobileDetailsState);
    return () => {
      listeners.delete(setShowMobileDetailsState);
    };
  }, []);

  const setShowMobileDetails = useCallback((valOrUpdater: boolean | ((prev: boolean) => boolean)) => {
    const nextVal = typeof valOrUpdater === 'function' ? valOrUpdater(globalShowMobileDetails) : valOrUpdater;
    
    // Only update if changed
    if (globalShowMobileDetails !== nextVal) {
      globalShowMobileDetails = nextVal;
      listeners.forEach((listener) => listener(nextVal));
    }
  }, []);

  return { showMobileDetails, setShowMobileDetails };
}
